module.exports = __webpack_public_path__ + "img/Perks-Gift-30.ad17c7a7.png";